module.exports = __webpack_public_path__ + "img/img_8_technology_retail@3x.3e864ea6.png";